/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import {
    bottomButtonsGridItem,
    buttonsGridItem,
    cancelButton,
    removeIcon,
    titleGridItems,
} from "@monsma/App/WidgetExtensions/Budget/BudgetExtension";
import { configureBudgetStyles } from "@monsma/Overrides/Widgets/Budget/ConfigureBudget";
import { css } from "styled-components";

configureBudgetStyles.titleGridItems = titleGridItems;

configureBudgetStyles.buttonsGridItem = buttonsGridItem;

configureBudgetStyles.cancelButton = cancelButton;

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
    `,
};

configureBudgetStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};

configureBudgetStyles.budgetYearEndGridItem = {
    width: 12,
    css: css`
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: block;
                `,
                css`
                    display: block;
                `,
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
            ])}
    `,
};

configureBudgetStyles.customBudgetPeriodInput = {
    type: "number",
    min: 1,
    max: 13,
    cssOverrides: {
        formField: css`
            width: 55px;
            display: inline-block !important;
            margin-right: 20px;
            margin-top: 4px;
        `,
        inputSelect: css`
            padding-right: 5px;
            &:focus {
                padding-right: 5px;
            }
        `,
    },
};

configureBudgetStyles.removeIcon = removeIcon;

configureBudgetStyles.xConfigureBudgetStyles = {
    bottomButtonsGridItem: { ...bottomButtonsGridItem },
};
